<script setup>
import { ref, onMounted } from 'vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseDatePicker from '@/src/vueComponent/BaseDatePicker.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import { ClearOutlined, SearchOutlined } from '@ant-design/icons-vue'
import dayjs from 'dayjs'
import mySwal from '@/src/javascripts/plugins/mySwal.js'

const categoryList = ref(
  Object.entries(I18n.t('enumerize.document.state'))
    .filter(([key]) => key !== 'add') // Remove 'add'
    .map(([value, label]) => ({ value, label }))
)
categoryList.value.unshift({ value: 'all', label: '選擇全部' }) // Add 'all'

const searchInfo = ref({
  document_index: '',
  start_date: '',
  end_date: '',
  category: 'all'
})

onMounted(() => {
  const searchParams = new URLSearchParams(window.location.search)
  searchInfo.value.document_index = searchParams.get('document_index')
  searchInfo.value.start_date = searchParams.get('start_date')
  searchInfo.value.end_date = searchParams.get('end_date')
  searchInfo.value.category = searchParams.get('category') ?? 'all'
})

const checkDateOnlyOneChosen = () => {
  return (
    (searchInfo.value.start_date && !searchInfo.value.end_date) ||
    (!searchInfo.value.start_date && searchInfo.value.end_date)
  )
}

const checkDateConverse = () => {
  return dayjs(searchInfo.value.start_date).isAfter(dayjs(searchInfo.value.end_date))
}

const handleSubmit = (event) => {
  if (checkDateOnlyOneChosen()) {
    mySwal.error({
      title: '請選擇一個日期區間'
    })
    event.preventDefault()
  } else if (checkDateConverse()) {
    mySwal.error({
      title: '起始日期不得晚於結束日期'
    })
    event.preventDefault()
  } else {
    event.target.submit()
  }
}
</script>

<template>
  <form
    class="min-w-[248px] p-4"
    action="/documents"
    accept-charset="UTF-8"
    method="get"
    @submit.prevent="handleSubmit"
  >
    <div class="mb-2">
      <BaseTextInput
        :label="'文件編號'"
        :name="'document_index'"
        v-model="searchInfo.document_index"
      ></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseDatePicker :label="'日期（起）'" :name="'start_date'" v-model="searchInfo.start_date" />
    </div>
    <div class="mb-2">
      <BaseDatePicker :label="'日期（迄）'" :name="'end_date'" v-model="searchInfo.end_date" />
    </div>
    <div class="mb-2">
      <BaseSelect
        :label="'類別'"
        :name="'category'"
        :optionList="categoryList"
        :optionsSelected="searchInfo.category"
        @select="searchInfo.category = $event"
      />
    </div>
    <div class="mb-2 flex justify-between gap-3 py-3">
      <a href="/documents" class="btn btn-ghost text-xl">
        <ClearOutlined />
        清空
      </a>
      <button
        type="submit"
        class="block flex-1 rounded-md border-scp-royal-blue bg-scp-royal-blue p-3 text-center text-xl font-semibold text-white hover:bg-blue-800"
      >
        <SearchOutlined />
        查詢
      </button>
    </div>
  </form>
</template>
